<template>
  <b-container fluid>
    <div v-if="isLoading">
      <b-spinner
        v-if="isLoading"
        type="grow"
        class="text-center"
        style="margin-top: 10%; position:absolute;"
        variant="primary"
      ></b-spinner>
    </div>
    <b-navbar toggleable="lg" type="dark" variant="light">
      <b-navbar-brand href="#" class="text-dark">
        <strong>IDD+ COUNTER</strong>
      </b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-nav-form>
            <b-form-group
              label-cols-sm="3"
              label-align-sm="right"
              label-size="sm"
              label-for="filterInput"
            >
              <b-input-group size="sm">
                <b-form-input
                  v-model="filter"
                  type="search"
                  id="filterInput"
                  placeholder="Type to Search"
                ></b-form-input>
                <b-input-group-append>
                  <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-nav-form>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <b-row style="height:570px; overflow-y:auto;">
      <b-col cols="12" class="table-col">
        <b-table
          ref="table"
          id="my-table"
          :fields="fields"
          :busy.sync="isLoading"
          :items="myProvider"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          responsive="sm"
          :per-page="perPage"
          :current-page="currentPage"
          :filter="filter"
        >
          <template v-slot:cell(color)="data">
            <b-badge v-if="data.item.color == 1" variant="success">Green</b-badge>
            <b-badge v-if="data.item.color == 2" variant="warning">Amber</b-badge>
            <b-badge v-if="data.item.color > 2" variant="danger">Red</b-badge>
          </template>
        </b-table>
        <p class="mt-3">Current Page: {{ perPage }} rows</p>
        <b-row>
          <b-col cols="2">
            <b-form-select v-model="perPage" id="perPageSelect" size="sm" :options="pageOptions"></b-form-select>
          </b-col>
          <b-col>
            <b-pagination
              class="float-right"
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
              first-text="First"
              prev-text="Prev"
              next-text="Next"
              last-text="Last"
              aria-controls="my-table"
            ></b-pagination>
          </b-col>
        </b-row>
      </b-col>
      <!-- secont col -->
    </b-row>
  </b-container>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { HTTP } from "../utils/HTTP";
import { Helper } from "../helpers";
import AppHeader from "../components/header/header";
import AppLoader from "../components/Loader/Loader";
import accounting from "accounting";
import moment from "moment";

export default {
  components: {
    AppHeader,
    AppLoader
  },
  props: {
    moreParams: Object
  },
  data() {
    return {
      totalRows: 0,
      isLoading: false,
      filter: null,
      perPage: 10,
      currentPage: 1,
      sortBy: "id",
      sortDesc: false,
      fields: [
        { key: "number", label: "No.", sortable: true },
        { key: "name", label: "Third Party Vendor Name", sortable: true },
        { key: "color", label: "IDD+ Risk Color", sortable: true }
      ],
      pageOptions: [5, 10, 25, 50, 75, 100]
    };
  },

  computed: {
    rows() {
      return this.totalRows;
    }
  },
  mounted() {},
  methods: {
    async myProvider() {
      let formData = {
        filter: this.filter,
        sort: this.sortBy + "|" + (this.sortDesc == true ? "desc" : "asc"),
        per_page: this.perPage,
        page: this.currentPage,
        companyId: this.moreParams.companyId,
        endDate: this.moreParams.endDate,
        startDate: this.moreParams.startDate
      };

      this.isLoading = true;
      let token = "Bearer " + localStorage.getItem("accessToken");
      let result = HTTP("post", "v1/reports/iddpluscounter", formData, {
        Authorization: token
      });

      return result
        .then(response => {
          const items = response.data.data;
          this.isLoading = false;
          this.totalRows = response.data.total;
          return items;
        })
        .catch(error => {
          this.isLoading = false;
          return [];
        });
    }
  }
};
</script>

<style scoped>
.table-col {
  max-height: calc(100vh - 140px);
  overflow-y: scroll;
}
</style>

